import { createSelector } from 'reselect'

export const getSubmitTechnicalInspectionForm = createSelector(
  state => state?.scheduleTechnicalInspection?.submitFormData ?? null,
  submitFormData => submitFormData
)
